import type { ReactNode } from "react";

type TableBodyActionPropsT = {
  icon: ReactNode;
  toolTip: string;
  action: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};

const TableBodyAction = ({
  icon,
  toolTip,
  action,
  disabled,
}: TableBodyActionPropsT) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return;
    action(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={disabled ? undefined : toolTip}
      aria-label={disabled ? undefined : toolTip}
      disabled={disabled}
      className={`flex w-3 h-3 rounded-full justify-center content-center items-center border-none bg-transparent ${disabled ? "text-brand-neutral-400 cursor-not-allowed" : "text-brand-neutral-900 cursor-pointer"}`.trim()}
    >
      {icon}
    </button>
  );
};

export default TableBodyAction;
